import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css'
import time from './helpers/time'

// ?- js console element superset that only executes when MIX_APP_DEBUG is true

const app = createApp(App).use(store).use(router).mount('#app')
// app.config.globalProperties.$sleep = time.sleep;